import BaseReportPDFDefinitionBuilder from "../BaseReportPDFDefinitionBuilder";
import {styles as baseStyles, tableLayouts as baseTablelayouts} from "../BaseReportPDFDefinitionBuilder"

export default class PDFDefinitionBuilder extends BaseReportPDFDefinitionBuilder {
    getAdditionalStyles() {
        return styles;
    }

    getAdditionalParameters() {
        return parameters;
    }
}

const styles = Object.assign({}, baseStyles,
    {
        notEstimated: {
            fontSize: 7,
            color: '#808080',
            alignment: 'center'
        }
    })

const parameters = Object.assign({}, baseTablelayouts,
    {
        dataTableStyles: {
            tableStyle: 'reportRow'
        },

        Portrait: {
            columnWidth: {
                levels: 40,
                levelsWide: 60,
                totals: 10,
                estimatedTime: 10,
                variance: 10
            },
            A4: {
                limitOfLinesInTextCell: 62
            },
            Letter: {
                limitOfLinesInTextCell: 56
            }
        },
        Landscape: {
            columnWidth: {
                levels: 40,
                levelsWide: 60,
                totals: 10,
                estimatedTime: 10,
                variance: 10
            },
            A4: {
                limitOfLinesInTextCell: 40
            },
            Letter: {
                limitOfLinesInTextCell: 42
            }
        }
    })


// WEBPACK FOOTER //
// ./web/js/pdf/evaReport/PDFDefinitionBuilder.js